import * as React from 'react';
import styles from '../../styles/flyouts/tasks/Properties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { __, validateForm, getURLParam } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import classNames from 'classnames';
import EditStageForm from '../../forms/stages/EditStageForm';
import {
  listProjectStages,
  readStage,
  updateStage,
} from '../../redux/actions/table/stages';
import { listActiveModules } from '../../redux/actions/general/active_modules';

const Properties = ({ data, collapsed, is_project_administrator, match }) => {
  const handleSubmit = (formData) => {
    return validateForm(
      updateStage(formData.id, _.omit(formData, ['id'])).then(() => {
        listProjectStages(match.params.project);

        readStage(getURLParam('id'));

        listActiveModules();

        setNotification(__('project.stages.notification.saved'));
      })
    );
  };

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      <EditStageForm
        isProjectAdministrator={is_project_administrator}
        onSubmit={handleSubmit}
        initialValues={{
          ..._.pick(data, ['id', 'name', 'description', 'status']),
          date: {
            start: data.start_date,
            end: data.end_date,
          },
        }}
        projectLanguages={data.languages}
      />
    </div>
  );
};

export default withRouter(Properties);
